import { useRouter } from 'next/router';
import { Button } from '@fabric-ds/react';
import cn from 'classnames';

import styles from './TopBarMap.module.css';

type TopBarMapProps = {
    toggleFilterState: () => void;
    filtersOpen: boolean;
    numResults: number;
};

export const TopBarMapMobile = ({ toggleFilterState, filtersOpen, numResults }: TopBarMapProps) => {
    const router = useRouter();
    const searchParams = new URLSearchParams(router.query as Record<string, string>);

    return (
        <div className={cn(styles.topbarMapMobile, 'md:hidden grid grid-cols-3 p-8 items-center border-b fixed left-0 right-0 bg-white')}>
            {filtersOpen ? (
                <div />
            ) : (
                <Button small href={`${router.basePath}/resultat/?${searchParams.toString()}`} data-testid="closeMapButton">
                    Lukk kart
                </Button>
            )}
            <output className="text-center font-bold" data-testid="resultCount">
                {numResults}
            </output>
            <Button small className="ml-auto" primary={filtersOpen} onClick={toggleFilterState} data-testid="showFilterButton">
                {filtersOpen ? 'Vis resultat' : 'Vis filter'}
            </Button>
        </div>
    );
};
